export default {
  methods: {
    api: async function(type, payload){
      const url = 'https://script.google.com/macros/s/AKfycbx3nKY5REm3TlBhTaRM5MzqvucopkUftTb-7OkuU0HxJDWZn6KM/exec'
      const method = 'POST'
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'text/plain'
      }
      const mode = 'cors'
      const body = `{"type": "${type}","applicant": "${this.user}","payload": ${JSON.stringify(payload)}}`

      let json = await (await fetch(url, {method, headers, mode, body})).json();
      if (json.status != 'success') {
        throw new Error(json.message)
      }
      return json
    },
    num2date: function(num){
      return this.$moment(String(num), "YYYYMMDD")
    },
    date2num: function(date){
      return Number(this.$moment(date).format("YYYYMMDD"))
    },
  }
}